import styled from 'styled-components';

export const ContentStyled = styled.div`
    width: 100%;
    padding-top: 100px;

    @media (max-width: 1000px){
        padding-top: 70px;
    }
`;